import { locationHistory, previousAlerts } from './detail-notification'

export const dataDemoDriverBehavior = [
  {
    rawAlertId: 15,
    alertCode: 8,
    isResolved: null,
    alert: {
      alertCode: 8,
      descriptionEng: 'Overspeed',
      descriptionIdn: 'Kecepatan Melebih Batas Aman',
      fullDescriptionEng: 'The vehicle is moving faster than the set speed limit',
      fullDescriptionIdn: 'Kendaraan melaju lebih cepat dari batas kecepatan yang ditetapkan',
      iconUrl:
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/assets/alert_icon/Red+Icon/RED_truck_moving.svg',
      enabledInRule: true,
      alertCategories: [
        {
          alertCategoryId: 2,
          __typename: 'AlertCategory',
        },
      ],

      alertData: '89|300|9216.0100',
      __typename: 'AlertCode',
    },
    driver: {
      fullname: 'Wahyu',
      userId: 31571,
      photograph: null,
      phoneNo: null,
      __typename: 'User',
    },
    driverId: 31571,
    createdOn: '2025-08-28T01:40:44.000Z',
    alertTrigger: 80,
    alertFlag: true,
    alertData: '89|300|9216.0100',
    vehicle: {
      id: 24337,
      licensePlate: 'Demo E',
      imei: '222',
      device: {
        phoneNo: null,
        deviceCode: 6001,
        __typename: 'Device',
      },
      vehicleType: {
        category: 'Pick Up',
        icon: 'smallTruck',
        __typename: 'VehicleType',
      },
      sensor: [
        {
          sensorCode: 38,
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 35,
          statusText: '1,2',
          __typename: 'SensorResponseType2',
        },
        {
          sensorCode: 6,
          __typename: 'SensorResponseType2',
        },
      ],
      __typename: 'Vehicle',
    },
    formattedAlertData: '89.00',
    longitude: 112.7256888,
    latitude: -7.7881838,
    geofence: '-',
    additionalData: null,
    isImportant: false,
    isUrgent: false,
    isRead: true,
    lastUserFeedback: null,
    vehicleId: 24337,
    readOn: '2025-08-28T01:54:28.000Z',
    geofences: [],
    resolvedOn: null,
    resolvedBy: null,
    resolver: null,
    userLogs: [],
    isFalseAlert: null,
    locationHistory: locationHistory,
    previousAlerts: previousAlerts,
    media: [
      {
        downloadId: 1,
        identifier: 'P',
        mediaFilename: 'overspeed-image-capture-depan.jpg',
        channel: 1,
        status: 'S',
      },
      {
        downloadId: 2,
        identifier: 'P',
        mediaFilename: 'overspeed-image-capture-driver.jpg',
        channel: 2,
        status: 'S',
      },
      {
        downloadId: 3,
        identifier: 'V',
        mediaFilename: 'overspeed-video-depan.mp4',
        channel: 1,
      },
      {
        downloadId: 4,
        identifier: 'V',
        mediaFilename: 'overspeed-video-driver.mp4',
        channel: 2,
      },
    ],

    statusText: '1,2',
    mediaStatus: 'Success',
    __typename: 'RawAlert',
  },
]
